import axios from 'axios';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import 'dplayer/dist/DPlayer.min.css';
import VueChartkick from 'vue-chartkick';
import Highcharts from 'highcharts';
import '@/assets/styles/override.scss';
import './plugins/vuetify';
import './plugins/highcharts';
import './plugins/pell';
import './plugins/jodit';
import App from './modules/app';
// import Loading from './views/Loading';
import router from './router/';
import store from './store/';
import messages from './localization/messages';
import './utils/tokenInterceptor';
import './utils/responseInterceptor';
import './utils/filters';

Vue.use(VueI18n);
Vue.use(VueChartkick, { adapter: Highcharts });

Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: 'de-DE',
  fallbackLocale: 'de-DE',
  messages,
});

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
router.replace({ path: '*', redirect: '/' });

const initMainApp = () => {
  // const i18n = initLocalization();
  console.log(messages);
  new Vue({
    router,
    store,
    i18n,
    moment,
    render: h => h(App),
  }).$mount('#app');
};

// const initLoadingApp = () => {
//   const loadingApp = new Vue({
//     render: h => h(Loading),
//   }).$mount('#loading');

//   loadingApp.dispose = () => {
//     loadingApp.$el.parentNode.removeChild(loadingApp.$el);
//     loadingApp.$destroy();
//   };

//   return loadingApp;
// };

// const ensureDependencies = () => new Promise((resolve) => {
//   /* if (localStorage.getItem(localizationKey)) {
//     resolve();

//     return;
//   } */

//   const loadingApp = initLoadingApp();

//   /* axios.get('/api/localization?locale=tr')
//     .then((res) => {

//       localStorage.setItem(localizationKey, JSON.stringify(res.data));
//       loadingApp.dispose();

//       resolve();
//     })
//     .catch(() => {
//       // TODO: Handle catch
//     }); */
// });

initMainApp();
// ensureDependencies().then(initMainApp);
